import http from "@/http-common";
import authHeader from "@/services/auth-header";

export const ticket = {
    namespaced: true,
    state: {
        tickets: []
    },

    mutations: {
        setTicketData(state, data) {
            state.tickets = data.map(ticket => {
                return {
                    id: ticket.id,
                    ticketName: ticket.ticketName,
                    eventName: ticket.eventName,
                    banner: ticket.banner,
                    logo: ticket.logo,
                    format: ticket.format,
                    color: ticket.color,
                    useUserCategories: ticket.useUserCategories,
                };
            });
        },
        addTicket(state, data) {
            state.tickets.push(data);
        }
    },

    getters: {
        getTickets(state) {
            return state.tickets.filter(t => t.id !== 0);
        },
        getTicket: (state) => (id) => {
            const result = state.tickets.find(t => t.id === id);
            return result === undefined ? 0 : result;
        },
        getIndexOf: (state) => (ticket) => {
            return state.tickets.indexOf(ticket);
        },
        getEventList(state) {
            return state.tickets.sort((a, b) => {
                const nameA = a.ticketName.toUpperCase(); // ignore upper and lowercase
                const nameB = b.ticketName.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            }).filter(t => t.id !== 0).map(ticket => {
                return {
                    id: 0,
                    creator: 1,
                    name: ticket.ticketName,
                    eventName: ticket.eventName,
                    location: "Ort",
                    plz: "12345",
                    street: "Musterstraße",
                    number: "1",
                    tel: "01234 56789",
                    date: "2024-01-01",
                    startTime: "12:00",
                    endTime: "",
                    size: 100,
                    companyID: ticket.companyID,
                    checkOut: true,
                    deadline: null,
                    createdAt: "",
                    ticketID: ticket.id,
                    banner: `data:image/*;base64,${ticket.banner}`,
                    color: ticket.color,
                }
            })
        },
    },

    actions: {
        async fetchTickets(context) {
            await http.get(`/leader/tickets`, {headers: authHeader()})
                .then(response => {
                    context.commit("setTicketData", response.data);
                })
                .catch(e => console.log(e));
        },
        async editTicket(context, {data, id}) {
            context.state.tickets[id] = data;
        },
        async deleteTicket(context, id) {
            context.state.tickets.splice(id, 1);
        },
    },

};